import {Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'achoo-popup',
  templateUrl: './achoo-popup.component.html',
  styleUrls: ['./achoo-popup.component.scss']
})
export class AchooPopupComponent {

  @ViewChild('content')
  public content: ElementRef;

  @Input()
  public modelTitle: string;

  @Input()
  public acceptBtnLabel: string;

  @Input()
  public cancelBtnLabel: string;

  @Output()
  public acceptCallback = new EventEmitter<any>();
  @Output()
  public cancelCallback = new EventEmitter<any>();
  // this callback will useful when the cancel callback is different from close callback for "X" icon
  @Output()
  public closeCallback = new EventEmitter<any>();

  @Input()
  public isAlertPopup: boolean | false;
  @Input()
  public isNotification = false;
  @Input()
  public isRoiSettingPopup = false;
  @Input()
  public isTermAndCondPopup = false;

  // Input for popup which doesn't use any share parts of component (e.g invalid-account-level-notification)
  // Keep these popup as normal style like before re-design
  @Input()
  public isSpecialPopup: boolean;

  onAccept(event) {
    this.acceptCallback.emit(event);
  }

  onCancel(event) {
    this.cancelCallback.emit(event);
  }

  onClose(evt) {
    if (this.closeCallback.observers.length > 0) {
      this.closeCallback.emit(evt);
    } else {
      this.onCancel(evt);
    }
  }

  get shouldShowCloseIcon() {
    return this.closeCallback.observers.length > 0 || this.cancelCallback.observers.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-popup/achoo-popup.component.ts